export function generateNameTokens(name) {
    const normalized = (name || '').toLowerCase().trim();
    if (normalized.length < 3) return normalized ? [normalized] : [];
    const set = new Set();
    for (let i = 0; i <= normalized.length - 3; i++) {
        set.add(normalized.substring(i, i + 3));
    }
    return Array.from(set);
}

export function lastSaturday() {
    const today = new Date();
    const currentDay = today.getDay(); // Get the current day of the week (0-6, where 0 is Sunday)

    const daysToSubtract = (currentDay + 1) % 7; // Calculate the number of days to subtract to reach the last Saturday
    const lastSaturday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - daysToSubtract);

    return lastSaturday;
}

export function getDateInYYMMDD(fdDate) {
    return String(fdDate.getFullYear()).substring(2) + String(fdDate.getMonth() + 1).padStart(2, "0") + String(fdDate.getDate()).padStart(2, "0");
}

export function getDateFromFDID(fdID) {
    // Extract year, month, and day from the ID
    const year = parseInt(fdID.substring(0, 2), 10) + 2000; // Convert YY to YYYY
    const month = parseInt(fdID.substring(2, 4), 10) - 1;   // Convert MM to 0-based month index
    const day = parseInt(fdID.substring(4, 6), 10);         // Extract DD

    // Return a new Date object
    return new Date(year, month, day);
}